// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_af-4";
export var collapsed = "_af-1";
export var headerBar = "_af-0";
export var leftHeaderContent = "_af-3";
export var subjectContainer = "_af-2";